// Autofocus is intentional
/* eslint-disable jsx-a11y/no-autofocus */
import React, { forwardRef, useContext, useRef } from 'react';
import { useOverlay } from '@react-aria/overlays';
import { useDialog } from '@react-aria/dialog';
import { FocusScope } from '@react-aria/focus';
import useMergedRef from '@react-hook/merged-ref';
import { pickAriaProps } from '../../interfaces/commonProps';
import { useLocale } from '../LocaleProvider';
import { Overlay } from '../DatePicker/Overlay';
import { PopoverContext, containerPadding } from './context';
import { StyledPopover, StyledPopoverBody, StyledPopoverContainer, StyledTip, StyledTriangle, StyledVisuallyHiddenButton, } from './Popover.styles';
const Tip = (props) => (React.createElement(StyledTip, { ...props },
    React.createElement(StyledTriangle, { points: "10 0 20 12 0 12" })));
export const PopoverBody = ({ children }) => (React.createElement(StyledPopoverBody, null, children));
const PopoverContainer = forwardRef(function PopoverContainer({ children, open = false, onClose, placement = 'bottom', autoFocus = false, tip, tipProps, triggerRef, ...restProps }, ref) {
    const { popover: locale } = useLocale();
    const popoverRef = useRef(null);
    const getRef = useMergedRef(ref, popoverRef);
    const { overlayProps } = useOverlay({
        onClose,
        isOpen: open,
        isDismissable: true,
        shouldCloseOnInteractOutside: (target) => { var _a; 
        // don't call `onClose` when the invoker is the trigger
        return !((_a = triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) === null || _a === void 0 ? void 0 : _a.contains(target)); },
    }, popoverRef);
    const { dialogProps } = useDialog(pickAriaProps(restProps), popoverRef);
    return (React.createElement(FocusScope, { contain: true, restoreFocus: true, autoFocus: autoFocus },
        React.createElement(StyledPopover, { open: open, ...restProps, ...overlayProps, ...dialogProps, containerPadding: containerPadding, placement: placement, tip: tip, ref: getRef },
            React.createElement(StyledPopoverContainer, null, children),
            tip && React.createElement(Tip, { ...tipProps, placement: placement }),
            React.createElement(StyledVisuallyHiddenButton, { onClick: onClose }, locale.closeLabel))));
});
export const Popover = ({ children, ...restProps }) => {
    const { open, ref, onExiting, onExited, ...contextProps } = useContext(PopoverContext);
    return (React.createElement(Overlay, { open: open, transitionDuration: 125, onExiting: onExiting, onExited: onExited },
        React.createElement(PopoverContainer, { ref: ref, open: open, ...restProps, ...contextProps }, children)));
};
//# sourceMappingURL=Popover.js.map